<template>
  <div
    class="panel panel-default strategy-collections-breadcrumb"
    v-if="collections.length > 0">
    <div class="panel-heading">This strategy appears in the following collection<template v-if="collections.length > 1">s</template>:</div>
    <ul class="list-group">
      <li
        class="list-group-item"
        :key="collection.uuid"
        v-for="collection in collections"><router-link :to="{name: 'CuratedCollection', params: {id: collection.uuid}}" target="_blank">{{ collection.name }}</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StrategyCollectionBreadcrumb',
  props: {
    collections: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.strategy-collections-breadcrumb {
  margin-top: 1em;
}
</style>
